import React from 'react';
import {useTranslation} from 'react-i18next';
import s from './InfoColorPanel.module.css';

export type QuickFilterKey =
  | 'not_active_contract'
  | 'manager_type'
  | 'old_contract'
  | 'old_tree';

type InfoColorPanelProps = {
  activeKey: QuickFilterKey | null;
  onSelect: (key: QuickFilterKey) => void;
};

type OptionConfig = {
  labelKey: string;
  key: QuickFilterKey;
  colorClass: string;
};

const options: OptionConfig[] = [
  {labelKey: 'Неактивовані', key: 'not_active_contract', colorClass: s.optionsItemRed},
  {
    labelKey: 'Партнери у кваліфікації',
    key: 'manager_type',
    colorClass: s.optionsItemGreen,
  },
  {
    labelKey: 'Втрачають контракт',
    key: 'old_contract',
    colorClass: s.optionsItemBrown,
  },
  {
    labelKey: 'Втрачають структуру',
    key: 'old_tree',
    colorClass: s.optionsItemBlue,
  },
];

const InfoColorPanel: React.FC<InfoColorPanelProps> = ({activeKey, onSelect}) => {
  const {t} = useTranslation();

  return (
    <div className={s.infoColorPanel}>
      <div className={s.optionsRow}>
        {options.map(({labelKey, key, colorClass}) => (
          <div className={s.optionsColumn} key={key}>
            <button
              type="button"
              className={`${s.optionsItem} ${colorClass} ${activeKey === key ? s.optionsItemActive : ''}`}
              onClick={() => onSelect(key)}
              aria-pressed={activeKey === key}
            >
              {t(labelKey)}
            </button>
          </div>
        ))}
      </div>
    </div>
  );
};

export default InfoColorPanel;
